// src/components/website/Navbar.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className="navbar" style={{
      boxShadow: scrolled ? '0 2px 12px rgba(0,0,0,0.08)' : 'none'
    }}>
      <Link to="/" className="navbar-brand">
        <span>🛡️</span> CivicSetu
      </Link>

      <ul className="navbar-links">
        <li><Link to="/#how-it-works">How It Works</Link></li>
        <li><Link to="/#features">Features</Link></li>
        <li><Link to="/pricing">Pricing</Link></li>
        <li><Link to="/#use-cases">Use Cases</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>

      <div className="navbar-cta">
        <Link to="/bulk/login" className="web-btn web-btn-outline web-btn-sm">
          Bulk Orders
        </Link>
        <a
          href="https://play.google.com/store/apps/details?id=com.civicsetu.app"
          target="_blank"
          rel="noreferrer"
          className="web-btn web-btn-primary web-btn-sm"
        >
          📱 Download App
        </a>
        {/* Admin Panel link — matches existing button style */}
        <Link to="/admin/login" className="web-btn web-btn-outline web-btn-sm">
          ⚙️ Admin
        </Link>
      </div>
    </nav>
  );
}
